"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Checkbox {
    forwardEvent(eventName, originalEvent, el) {
        const elRef = el || this.el.querySelector("input");
        const value = elRef.value;
        const checked = elRef.checked;
        this.emit(`${eventName}`, {
            originalEvent,
            value,
            checked,
        });
    }
}
module.exports = Checkbox;
